import { PROXY_EMAIL_DOMAIN } from "@/core/constants";

export default function isProxyEmail(email) {
  return email.endsWith(PROXY_EMAIL_DOMAIN);
}
